import React, { SVGProps } from 'react';

export const VideoPlayIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M6.38 3h1.87v6H3V6.38C3 4.12 4.12 3 6.38 3ZM14.25 3h-4.5v6h4.5V3ZM21 6.38V9h-5.25V3h1.87C19.88 3 21 4.12 21 6.38Z"
    />
    <path
      fill="currentColor"
      d="M15.75 9V3h-1.5v6h-4.5V3h-1.5v6H3v8.62C3 19.87 4.12 21 6.38 21h11.24c2.26 0 3.38-1.13 3.38-3.38V9h-5.25Z"
      opacity=".4"
    />
    <path
      fill="currentColor"
      d="m14.581 13.754-3.149-1.927a.941.941 0 0 0-1.433.799v3.747a.94.94 0 0 0 1.433.799l3.15-1.927a.873.873 0 0 0 0-1.491Z"
    />
  </svg>
);
